import React, { Component } from 'react'
import { Button } from 'react-bootstrap'
import PlayerEvaluationCard from '../components/PlayerEvaluationCard'
import Tools from '../../../../../Tools'

const Metrics = [
    'Crossing Accuracy',
    'Finishing Accuracy'
]

class Attacking extends Component {

    isMetricEqual = metric => this.props.insertedImage && this.props.insertedImage.metric === metric;

    render() {        
        return (
            <div className="attacking-tab">
                <div className="tab-content-header">
                    <h5 className="title">Attacking</h5>
                    <Button variant="link">Reset All</Button>
                </div>
                <div className="tab-content-body">
                    {
                        Metrics.map(metric => {
                            const metricKey = Tools.convertToDashCase(metric);
                            return (
                                <PlayerEvaluationCard
                                    key={metricKey}
                                    title={metric}
                                    insertedImage={this.isMetricEqual(metricKey) ? this.props.insertedImage : ''}
                                />
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}

export default React.memo(Attacking)
